module.exports = __webpack_public_path__ + "static/media/moderna_rendidora.51599a6a.png";